import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen, TabSet, Tab, Layout, RecordTabs} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Display,Button,EmptyState} from 'ktm-ui';
import toastr from 'toastr';
import ProductRecordScreen from 'enroll/product/Record';

interface IdsBenefits {
    Id:string;
    Name:string;
    Description:string;
    Policy_Id:string;
    Benefit:string;
};

export default KTMScreen({name:"enroll.policy.products"}, class extends React.Component<{policy_id:string}> {

    data:{
        dsBenefits:IdsBenefits[];
    }

    isAdding: boolean = false;

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsBenefits";
        await KTMApi.start(screen,{
            "@policy_id":this.props.policy_id,
        });
        if (this.data.dsBenefits || this.data.dsBenefits.length){
          //  await screen.triggerAction(this.show_record);
        }
        screen.title = "Plan";
    }

    main({draw}:RenderEvent){
        return <Layout>
            {/* {draw(this.tabset)} */}
            {draw(this.tabContent)}
        </Layout>
    }

    tabset({field,draw,action,collection,getValue}:RenderEvent){
        return (<RecordTabs collection={collection("@dsBenefits")} template="tabContent" />)
    }

    tabContent({getValue}:RenderEvent){
        return <ProductRecordScreen policyBenefit_id={getValue("Id")}/>
    }


    empty_state({field,draw,action}:RenderEvent){
        return (
            <EmptyState label="No products have been added yet." icon="money">
                <Button action={action(this.add)} label="Add Product" style="primary"/>
            </EmptyState>
        );
    }

    async add({screen}:ActionEvent){
        if (this.isAdding) return;
        // If a product already exists, just refresh the layout — don't insert again.
        if (this.data.dsBenefits && this.data.dsBenefits.length > 0) {
            screen.showLayout(this.main);
            await screen.restart();
            return;
        }
        this.isAdding = true;
        let actionError: any = null;
        try {
            try {
                await KTMApi.action(screen, "create_spend_product", {
                    "@policy_id": this.props.policy_id,
                });
            } catch (e) {
                actionError = e;
                console.error("create_spend_product failed", e);
            }
            // Force the layout switch off empty-state before re-running Start(),
            // so even if restart() doesn't re-evaluate the layout choice, the
            // user sees the products view rather than the stale empty state.
            screen.showLayout(this.main);
            try {
                await screen.restart();
            } catch (e) {
                console.error("restart after create_spend_product failed", e);
            }
            if (actionError) {
                toastr.error(
                    "Could not add the product. Please refresh and try again, or contact support if the problem persists.",
                    "Add Product failed"
                );
            }
        } finally {
            this.isAdding = false;
        }
    }

});
